import React from "react";
import "./Services.css";
import CardSkill from "../CardSkill/CardSkill.jsx";

const Services = () => {
  return (
    <div className="services-div services-section">
      <div className="services-heading">
        <h3 className="services-title">Services</h3>
      </div>
      <div className="services-content">
        <div className="services-description">
          <p>
            At R.A. Engineering & Services (RAES), we pride ourselves on
            offering a comprehensive range of engineering and fabrication
            services tailored to meet the unique needs of our clients. Our
            services include:
          </p>
        </div>
        <div className="services-grid">
          <CardSkill
            icon={"toys_fan"}
            title="Ventilation System Design"
            description="Designing efficient and safe ventilation systems for commercial, healthcare, and industrial facilities."
            color={"#0066ff"}
          />
          <CardSkill
            icon={"air"}
            title="Air-Conditioning System Design"
            description="Creating reliable and energy-efficient air-conditioning solutions tailored to project requirements."
            color={"#0066ff"}
          />
          <CardSkill
            icon={"fire_extinguisher"}
            title="Fire-Protection System Design"
            description="Developing fire safety systems that comply with current codes and standards, ensuring maximum protection."
            color={"#0066ff"}
          />
          <CardSkill
            icon={"factory"}
            title="Steel and Metal Fabrication"
            description="Fabricating structural and custom metal components to meet project specifications and deadlines."
            color={"#0066ff"}
          />
          <CardSkill
            icon={"checklist"}
            title="Project Management and Consultation"
            description="Providing expert guidance and management to ensure projects are delivered efficiently and on schedule."
            color={"#0066ff"}
          />
        </div>

        <p>
          Our experienced team is dedicated to ensuring safety, efficiency, and
          compliance with current codes and standards across all our projects.
        </p>
      </div>
    </div>
  );
};

export default Services;
